import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchHHAuditHistory } from "../utils/formUtils";
import dayjs from "dayjs";
import { Link, useParams } from "react-router-dom";
import ContractPreviewPopup from "./ContractPreviewPopup";
import { USERROLE } from "../utils/commonConstant";

const AuditHistoryPopup = ({ open, onClose, contractVersionId }) => {
  const { clientId } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  const [elementPreview, setElementPreview] = useState({
    open: false,
    elements: [],
    previewKey: 0
  });
  // Define initial sort model
  const sortModel = [
    {
      field: "createdAt", // Sort by the FileName column
      sort: "desc", // 'asc' for ascending order, 'desc' for descending
    },
  ];
  // Fetch data when the dialog opens
  useEffect(() => {
    if (open && contractVersionId) {
      setLoading(true);
      fetchHHAuditHistory(contractVersionId)
        .then((data) => {
          const formattedData = data.map((item, index) => ({
            id: index + 1, // Unique ID for DataGrid
            contractVersionId: item.ContractVersionId,
            contractVersionName: item.ContractVersionName,
            metaData: item.MetaData,
            approvalType: item.ApprovalType,
            actionType: item.ActionType,
            changeBy: item.ChangeBy,
            createdAt: item.CreatedAt,
          }));
          setRows(formattedData);
        })
        .catch((error) => console.error("Error loading data:", error))
        .finally(() => setLoading(false));
    }
  }, [open, contractVersionId]);

  const handleVersionNameClick = (row) => {
    setElementPreview({
      open: true,
      elements: row.metaData,
      previewKey: row.id
    });
  };
  const handleClosePreview = () => {
    setElementPreview({
      open: false,
      elements: [],
      previewKey: 0
    });
  };
  // Define columns for the DataGrid
  const columns = [
    {
      field: "contractVersionName",
      headerName: "Contract Version",
      flex: 1,
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Tooltip title="Please click to preview" arrow>
          <Link
            href={`#`}
            underline="hover"
            sx={{
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
              },
            }}
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              handleVersionNameClick(params.row); // Call your click handler
            }}
          >
            {params.value}
          </Link>
        </Tooltip>
      ),
    },
    {
      field: "changeBy",
      headerName: "Actioned By",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "actionType",
      headerName: "Action",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "approvalType",
      headerName: "Approval Type",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1,
      headerClassName: "bold-header",
      renderCell: (params) => {
        if (params.value) {
          return dayjs(params.value).format("DD/MM/YYYY");
        }
        return "NA";
      },
    },
  ];

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
        <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold", marginTop: "2rem" }}>
          Audit History
        </Typography>

        <DialogContent>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 50, 100]}
            disableSelectionOnClick
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            sortModel={sortModel} // Set initial sort model
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ContractPreviewPopup
        key={elementPreview.previewKey}
        open={elementPreview.open}
        onClose={handleClosePreview}
        elements={elementPreview.elements}
        clientId={clientId}
        previewTitle={"Audit Preview"}
        trackChangeDisplayBy={USERROLE.ADMIN}
        isShowTrackHistory={true}
      />
    </>
  );
};

export default AuditHistoryPopup;
